import { createSlice } from "@reduxjs/toolkit"


var data=[]


if (localStorage.getItem("stock") !== null && localStorage.getItem("stock") !== undefined && localStorage.getItem("stock") !== "") {

    data = JSON.parse(localStorage.getItem("stock"))

}


const Insider = createSlice({

    name: "todos",
    initialState: data,
    reducers: {
        getstock: (state, action) => {
            localStorage.setItem("stock", JSON.stringify(action.payload.data))
            state = action.payload.data
            return state
        
          
        },

    },

})

export const {getstock } = Insider.actions;
export default Insider.reducer;